// Locked data for rate prediction
import { radiusTypes, trailerTypes } from "@/utils/constants";

export const lockedRatePrediction = {
  price: {
    minValue: 1743.01,
    maxValue: 2815.74,
    average: 2640,
    median: 0.0,
    label: "Average load price",
  },
  rate: {
    minValue: 2.43,
    maxValue: 3.93,
    average: 2.87,
    median: 0.0,
    label: "Average rate",
  },
  trend: 2.49,
  confidence: "high",
  cost: {
    totalCost: 444.56,
    fuelCost: 112,
    tollCost: 20.39,
    maintenanceCost: 71.6,
  },
  inboundLoadDynamic: "increasing",
  outboundLoadDynamic: "decreasing",
  loadsCsvUrl: null,
};

export const lockedModelRatePrediction = {
  averageLoadPrice: {
    minValue: 1710,
    maxValue: 3920,
    average: 2720,
    midLow: 2350,
    midHigh: 3130,
  },
  averageRate: {
    minValue: 1.85,
    maxValue: 4.25,
    average: 2.95,
    midLow: 2.55,
    midHigh: 3.4,
  },
};

export const lockedCustomModelRatePrediction = {
  averageLoadPrice: {
    minValue: 2100,
    maxValue: 3100,
    average: 2640,
    midLow: 2350,
    midHigh: 2850,
  },
  averageRate: {
    minValue: 2.28,
    maxValue: 3.37,
    average: 2.87,
    midLow: 2.55,
    midHigh: 3.1,
  },
};

// Locked data for market to market route
export const lockedMarketToMarketRoute = {
  distance: 993,
  durationInSeconds: 37800,
  // Simple polyline between Atlanta, GA and Alexandria, VA
  polyline: [
    [-84.388, 33.749], // Atlanta
    [-84.0, 34.0],
    [-83.0, 35.0],
    [-82.0, 36.0],
    [-81.0, 37.0],
    [-80.0, 38.0],
    [-77.0469, 38.8048], // Alexandria
  ],
};

// Locked location data for map
export const lockedPickupLocation = {
  placeName: "Alexandria",
  countryCode: "US",
  zip: "22314",
  stateCode: "VA",
  latitude: 38.81,
  longitude: -77.06,
  market: {
    city: "Alexandria",
    state: "VA",
    geographicalCenter: {
      latitude: 38.81,
      longitude: -77.06,
    },
  },
};
export const lockedDeliveryLocation = {
  placeName: "Virginia Beach",
  countryCode: "US",
  zip: "23451",
  stateCode: "VA",
  latitude: 36.87,
  longitude: -76.01,
  market: {
    city: "Norfolk",
    state: "VA",
    geographicalCenter: {
      latitude: 36.85,
      longitude: -76.29,
    },
  },
};

// Locked data for load volume
// Represents percentage of loads per day of the week [Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday]
export const lockedLoadVolume = [8, 11, 14, 10, 19, 20, 18];

// Locked data for search inputs (market potential)
export const lockedSearchInputMarketPotential = {
  pickup: {
    zip: "30303",
    countryCode: "US",
    placeName: "Atlanta",
    stateCode: "GA",
  },
  pickupQuery: "Atlanta, GA",
  pickupRadius: radiusTypes[0],
  trailerType: trailerTypes[0],
  pickupDate: "2025-01-15",
};

// Locked data for search inputs (load rates)
export const lockedSearchInputLoadRates = {
  pickup: {
    zip: "30303",
    countryCode: "US",
    placeName: "Atlanta",
    stateCode: "GA",
  },
  pickupQuery: "Atlanta, GA",
  delivery: {
    zip: "43215",
    countryCode: "US",
    placeName: "Alexandria",
    stateCode: "VA",
  },
  deliveryQuery: "Alexandria, VA",
  trailerType: trailerTypes[0],
  pickupDate: "2025-01-15",
  pickupRadius: radiusTypes[0],
  deliveryRadius: radiusTypes[0],
};

// Locked data for rate history
export const lockedRateHistory = [
  { year: 2025, month: 5, avgRPM: 1.45, avgPrice: 2230.0 },
  { year: 2025, month: 6, avgRPM: 1.55, avgPrice: 2180.0 },
  { year: 2025, month: 7, avgRPM: 1.48, avgPrice: 2185.0 },
  { year: 2025, month: 8, avgRPM: 1.6, avgPrice: 2190.0 },
  { year: 2025, month: 9, avgRPM: 2.21, avgPrice: 2195.0 },
  { year: 2025, month: 10, avgRPM: 1.84, avgPrice: 2160.0 },
  { year: 2025, month: 11, avgRPM: 1.84, avgPrice: 2050.0 },
  { year: 2025, month: 12, avgRPM: 1.61, avgPrice: 2055.18 },
  { year: 2025, month: 1, avgRPM: 1.42, avgPrice: 2090.95 },
  { year: 2025, month: 2, avgRPM: 1.38, avgPrice: 2085.18 },
  { year: 2025, month: 3, avgRPM: 1.52, avgPrice: 2120.18 },
  { year: 2025, month: 4, avgRPM: 1.83, avgPrice: 2130.18 },
  { year: 2026, month: 5, avgRPM: 1.62, avgPrice: 2170.77 },
];

// Locked data for RPM vs Distance
export const lockedRpmVsDistance = {
  labels: ["150 mi", "300 mi", "450 mi", "600 mi"],
  data: [11, 6.2, 4, 3],
};

// Locked data for market potential best outbounds
export const lockedMarketPotentialBestOutbounds = [
  {
    name: "Nashville, TN",
    zip: "37203",
    pickupName: "Athens, GA",
    deliveryName: "Jacksonville, FL",
    pickupZip: "30601",
    deliveryZip: "37203",
    distance: 1444.0,
    avgPrice: 1820.0,
    avgRPM: 2.0,
    confidence: "high",
    CMI: [650.25, 665.3, 680.35, 695.4, 710.45],
    topFivePercentRouteRPM: 2.15,
    topFivePercentOutboundRPM: 4.2,
    dailyProfitRoute: 420.75,
    dailyProfitOutbound: 580.9,
    tripDuration: 1,
    numberOfLoads: 7,
  },
  {
    name: "Columbus, GA",
    zip: "37203",
    pickupName: "Columbus, GA",
    deliveryName: "Charlotte, NC",
    pickupZip: "30601",
    deliveryZip: "37203",
    distance: 893.0,
    avgPrice: 1250.25,
    avgRPM: 1.53,
    confidence: "high",
    CMI: [640.15, 655.2, 670.25, 685.3, 700.35],
    topFivePercentRouteRPM: 2.05,
    topFivePercentOutboundRPM: 4.1,
    dailyProfitRoute: 410.65,
    dailyProfitOutbound: 570.8,
    tripDuration: 1,
    deadheadDistance: 999.0,
    numberOfLoads: 7,
  },
  {
    name: "Nashville, TN",
    zip: "37203",
    pickupName: "Athens, GA",
    deliveryName: "Nashville, TN",
    pickupZip: "30601",
    deliveryZip: "37203",
    distance: 679.0,
    avgPrice: 2060.0,
    avgRPM: 4.42,
    confidence: "medium",
    CMI: [660.35, 675.4, 690.45, 705.5, 720.55],
    topFivePercentRouteRPM: 2.25,
    topFivePercentOutboundRPM: 4.3,
    dailyProfitRoute: 430.85,
    dailyProfitOutbound: 590.95,
    tripDuration: 1,
    deadheadDistance: 212.0,
    numberOfLoads: 7,
  },
  {
    name: "Nashville, TN",
    zip: "37203",
    pickupName: "Athens, GA",
    deliveryName: "Jacksonville, FL",
    pickupZip: "30601",
    deliveryZip: "37203",
    distance: 1444.0,
    avgPrice: 1820.0,
    avgRPM: 2.0,
    confidence: "high",
    CMI: [650.25, 665.3, 680.35, 695.4, 710.45],
    topFivePercentRouteRPM: 2.15,
    topFivePercentOutboundRPM: 4.2,
    dailyProfitRoute: 420.75,
    dailyProfitOutbound: 580.9,
    tripDuration: 1,
    numberOfLoads: 7,
  },
  {
    name: "Columbus, GA",
    zip: "37203",
    pickupName: "Columbus, GA",
    deliveryName: "Charlotte, NC",
    pickupZip: "30601",
    deliveryZip: "37203",
    distance: 893.0,
    avgPrice: 1250.25,
    avgRPM: 1.53,
    confidence: "high",
    CMI: [640.15, 655.2, 670.25, 685.3, 700.35],
    topFivePercentRouteRPM: 2.05,
    topFivePercentOutboundRPM: 4.1,
    dailyProfitRoute: 410.65,
    dailyProfitOutbound: 570.8,
    tripDuration: 1,
    deadheadDistance: 999.0,
    numberOfLoads: 7,
  },
  {
    name: "Nashville, TN",
    zip: "37203",
    pickupName: "Athens, GA",
    deliveryName: "Nashville, TN",
    pickupZip: "30601",
    deliveryZip: "37203",
    distance: 679.0,
    avgPrice: 2060.0,
    avgRPM: 4.42,
    confidence: "medium",
    CMI: [660.35, 675.4, 690.45, 705.5, 720.55],
    topFivePercentRouteRPM: 2.25,
    topFivePercentOutboundRPM: 4.3,
    dailyProfitRoute: 430.85,
    dailyProfitOutbound: 590.95,
    tripDuration: 1,
    deadheadDistance: 212.0,
    numberOfLoads: 7,
  },
];

// Locked data for best outbounds
export const lockedBestOutbounds = [
  {
    id: 1,
    name: "Virginia Beach, VA",
    zip: "43215",
    pickupName: "Atlanta, GA",
    deliveryName: "Virginia Beach, VA",
    pickupZip: "30303",
    deliveryZip: "43215",
    distance: 9999,
    avgPrice: 9999.12,
    avgRPM: 12.22,
    confidence: "high",
    CMI: [727.27, 736.62, 745.97, 755.32, 764.67],
    topFivePercentRouteRPM: 2.55,
    topFivePercentOutboundRPM: 5.7,
    dailyProfitRoute: 706.94,
    dailyProfitOutbound: 905.27,
    tripDuration: 1,
    deadheadDistance: 30.0,
    numberOfLoads: 0,
  },
  {
    id: 2,
    name: "Virginia Beach, VA",
    zip: "43215",
    pickupName: "Atlanta, GA",
    deliveryName: "Virginia Beach, VA",
    pickupZip: "30303",
    deliveryZip: "43215",
    distance: 9999,
    avgPrice: 9999.12,
    avgRPM: 12.22,
    confidence: "high",
    CMI: [727.27, 736.62, 745.97, 755.32, 764.67],
    topFivePercentRouteRPM: 2.55,
    topFivePercentOutboundRPM: 5.7,
    dailyProfitRoute: 706.94,
    dailyProfitOutbound: 905.27,
    tripDuration: 1,
    deadheadDistance: 30.0,
    numberOfLoads: 0,
  },
  {
    id: 3,
    name: "Virginia Beach, VA",
    zip: "60602",
    pickupName: "Atlanta, GA",
    deliveryName: "Virginia Beach, VA",
    pickupZip: "30303",
    deliveryZip: "60602",
    distance: 718.0,
    avgPrice: 9999.12,
    avgRPM: 12.22,
    confidence: "high",
    CMI: [645.58, 653.88, 662.18, 670.48, 678.77],
    topFivePercentRouteRPM: 2.09,
    topFivePercentOutboundRPM: 10.69,
    dailyProfitRoute: 344.7,
    dailyProfitOutbound: 1005.3,
    tripDuration: 2,
    deadheadDistance: 30.0,
    numberOfLoads: 2,
  },
  {
    id: 4,
    name: "Virginia Beach, VA",
    zip: "60602",
    pickupName: "Atlanta, GA",
    deliveryName: "Virginia Beach, VA",
    pickupZip: "30303",
    deliveryZip: "60602",
    distance: 718.0,
    avgPrice: 9999.12,
    avgRPM: 12.22,
    confidence: "high",
    CMI: [645.58, 653.88, 662.18, 670.48, 678.77],
    topFivePercentRouteRPM: 2.09,
    topFivePercentOutboundRPM: 10.69,
    dailyProfitRoute: 344.7,
    dailyProfitOutbound: 1005.3,
    tripDuration: 2,
    deadheadDistance: 30.0,
    numberOfLoads: 2,
  },
];
